module.exports = __webpack_public_path__ + "6f7aeefb2cbfde661bde65c3b65d558c.glb";